module.exports = __webpack_public_path__ + "static/centaur-0316a993e85ef34740f76595edf96631.jpg";